
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const capitao: Operator = {
	id: 'capitao',
	name: 'Capitão',
	role: 'Attacker',
	org: 'BOPE',
	squad: 'VIPERSTRIKE',
	ratings: {
		health: 1,
		speed: 3,
		difficulty: 2
	},
	meta: {
		gender: 'm',
		country: 'br',
		season: 'Y1S3',
		height: 183,
		weight: 86,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Vincente Souza',
		birthplace: 'Nova Iguacu, Brazil'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#3e7f3f"></path><path d="M287 284.083H62.778L174.993 68.271z"></path><path d="M286.111 170.333c-42.17-23.349-81.983-23.533-110.778-23.667-28.082-.13-61.613.082-99.667 17.889C49.974 176.579 31.885 192.1 20.75 203.25l154.583 56.005 153.833-56.005c-8.918-9.132-23.123-21.88-43.055-32.917m-110.778 61.556L69.722 195.111c16.902-9.409 54.57-27.412 105.611-27.333 50.66.078 88.049 17.928 104.944 27.333z"></path><path d="m166.75 256.389-9.5-3.444v31.139h9.5zm16.5 0 9.5-3.444v31.139h-9.5zm113-71.222c-4.202-2.889-22.943-15.48-51.238-23.585-20.208-5.788-38.43-7.323-52.751-7.267l-.122 61.129-9.82 3.429v10.584l19.723-7.208v-57.667a169.2 169.2 0 0 1 42.379 6.82c23.411 6.909 40.895 17.602 52.127 25.809L178 240.083V130.349l11.875 3.109-14.542-37.167-15.292 37.167 11.875-3.109v109.734L53.368 197.211c11.233-8.207 28.717-18.899 52.127-25.809a169.3 169.3 0 0 1 42.379-6.82v57.667l19.723 7.208v-10.584l-9.821-3.429-.122-61.129c-14.321-.057-32.543 1.478-52.751 7.267-28.295 8.105-47.036 20.696-51.238 23.585a164 164 0 0 0-19.167 15.417l140.833 51.167 140.083-51.167a163.5 163.5 0 0 0-19.164-15.417" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-capitao'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
